import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';

import { __ } from '../../../../utils.jsx';

var UploadPanel = createReactClass({
  propTypes: {
    onUploadClick: PropTypes.func,
  },

  getDefaultProps: function() {
    return {
      onUploadClick: function() {},
    };
  },

  getInitialState: function() {
    return {
      file: null,
    };
  },

  onDrop: function(e) {
    e.preventDefault();

    var files;

    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    for (var i = 0; i < files.length; i++) {
      files[i].preview = URL.createObjectURL(files[i]);
    }

    files = Array.prototype.slice.call(files);
    if (this.props.onSelectFiles) {
      this.props.onSelectFiles(files);
    }
  },

  render: function() {
    var filePreview = null;
    if (this.state.file) {
      filePreview = this.state.file.name;
    }
    return (
      <div className="buttons">
        <label>{__('Nahrať súbor')}:</label>
        {filePreview}
        <a href="javascript:void(0);" className="button browse">
          <input type="file" onChange={this.onDrop} multiple />
          <span>{__('Prehľadávať')}</span>
        </a>
      </div>
    );

    // <a className="button small-margin-left" onClick={this.onUpload}>
    //     <span>{__('Nahrať')}</span>
    // </a>
  },
});

export default UploadPanel;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/UploadPanel.jsx